import PelckmansLogo from '../../sidebar/components/PelckmansLogo';
import User from '../../sidebar/components/User';
import Menu from './components/Menu';

function ApplicationNavigation() {
  return (
    <header className="application-navigation">
      <div className="content">
        <div className="left-navigation">
          <PelckmansLogo />
        </div>
        <div className="right-navigation">
          <Menu />
          <User />
        </div>
      </div>
    </header>
  );
}

export default ApplicationNavigation;
